<template>
  <div class="team">
    <AppTable
      v-if="tableData.length"
      :fields="tableFields"
      :items="tableData"
    >
      <template #teamName="data">
        <BaseLink :href="`/team/${data.id}`">
          {{ data.teamName }}
        </BaseLink>
      </template>
      <template #creator="data">
        <BaseLink :href="`/user/${data.creatorId}`">
          {{ data.creator }}
        </BaseLink>
      </template>
    </AppTable>

    <p v-else class="h3">Пользователь не состоит ни в одной команде.</p>
  </div>
</template>

<script>
import AppTable from '@/components/AppTable'
import BaseLink from '@/components/Base/BaseLink'

export default {
  name: 'AppTeam',
  components: {
    BaseLink,
    AppTable
  },
  data () {
    return {
      tableFields: [
        { key: 'teamName', label: 'Название', sortable: true, slot: true },
        { key: 'creator', label: 'Создатель', sortable: true, slot: true },
        { key: 'count', label: 'Количество участников', sortable: true },
        { key: 'date', label: 'Дата создания', sortable: true }
      ],
      tableData: []
    }
  },
  created () {
    this.fetchTeam()
  },
  methods: {
    async fetchTeam () {
      try {
        const { data } = await this.$api.user.team(this.$route.params.id)
        const list = data?.list ?? []

        this.tableData = list.map(item => {
          const id = item?.id ?? ''
          const teamName = item?.title ?? ''
          const creatorId = item?.createdBy?.id ?? null
          const name = item?.createdBy?.name ?? ''
          const surname = item?.createdBy?.surname ?? ''
          const count = item?.count ?? ''
          const date = item?.createdAt ?? ''

          return {
            id,
            teamName,
            creatorId,
            creator: `${name} ${surname}`,
            count,
            date
          }
        })
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.team {}
</style>
